import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "flatpickr/dist/themes/material_blue.css";
import { format } from 'date-fns';

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Label,
    Button,
    Form,
    Input,
} from "reactstrap";

const defaultValue = {
    name: '',
    code: '',
    email: '',
    contactno: '',
    logo: '',
    region: '',
    ward: '',
    faculty_manager: '',
    services_rendered: '',
    address: '',
    comment: ''
}

import { addClinic, getClinic, getRegion, getWardByRegion } from "service/api";

const Addclinic = () => {
    const [clinic, setClinic] = useState(defaultValue);
    const [ward, setWard] = useState([]);
    const [Clinics, setClinics] = useState([]);
    const [file, setFile] = useState(null);
    const [region, setRegion] = useState([]);
    const [filePreview, setFilePreview] = useState(null);
    const navigate = useNavigate();
    const [emailError, setEmailError] = useState('');
    const [scheduleErrors, setScheduleErrors] = useState({}); 

    const onValueChange = async (e) => {
        const { name, value } = e.target;

        if (name === 'email') {
            const emailExists = Clinics.some(clinic => clinic.email === value);
            if (emailExists) {
                setEmailError('This email is already in use.');
            } else {
                setEmailError('');
            }
        }

        setClinic({ ...clinic, [e.target.name]: e.target.value });

        if (name === 'logo') {
            const selectedFile = e.target.files[0];
            setFile(selectedFile);
            setFilePreview(URL.createObjectURL(selectedFile));
        }

        if (name === 'region') {
            try {
                const fetchWard = await getWardByRegion(e.target.value);
                setWard(fetchWard.data);
            } catch (error) {
                console.error('Error fetching wards:', error);
            }
        }
    };

    useEffect(() => {
        const fetchRegions = async () => {
            try {
                const response = await getRegion();
                setRegion(response.data);
            } catch (error) {
                console.error("Error fetching regions: ", error);
            }
        }
        fetchRegions();
        fetchclinic();
    }, []);

    const fetchclinic = async () => {
        try {
            const response = await getClinic();
            setClinics(response.data);
        } catch (error) {
            console.error("Error fetching clinics: ", error);
        }
    }

    const handleAddClinic = async (e) => {
        e.preventDefault();

        // 🔹 prevent saving if duplicate errors exist
        const hasErrors = Object.values(scheduleErrors).some(err => err !== "");
        if (hasErrors) {
            toast.error("This schedule slot already exists.", {
                position: "top-center",
                autoClose: 2000,
            });
            return;
        }

        const formData = new FormData();
        for (const key in clinic) {
            formData.append(key, clinic[key]);
        }
        if (file) {
            formData.append('logo', file);
        }
        formData.append('schedule', JSON.stringify(formRows));
        formData.append('guestpractice', '0');
        formData.append('is_active', '1');

        await addClinic(formData);
        navigate("/clinic");
        toast.success("Practice saved successfully.", {
            position: "top-center",
            autoClose: 1500,
        })
    }

    const [formRows, setFormRows] = useState([
        { id: 1, from: '', to: '', duration: '', appointments: 0 }
    ]);

    const onAddFormRow = () => {
        const newRow = {
            id: formRows.length + 1,
            from: '',
            to: '',
            duration: '',
            appointments: 0
        };
        setFormRows([...formRows, newRow]);
    };

    const onDeleteFormRow = id => {
        if (id !== 1) {
            const modifiedRows = formRows.filter(row => row.id !== id);
            setFormRows(modifiedRows);

            // also remove error state
            const updatedErrors = { ...scheduleErrors };
            delete updatedErrors[id];
            setScheduleErrors(updatedErrors);
        }
    };

    const calculateAppointments = (from, to, duration) => {
        const fromTime = new Date(`1970-01-01T${from}:00`);
        const toTime = new Date(`1970-01-01T${to}:00`);
        const durationMinutes = parseInt(duration);

        if (!isNaN(durationMinutes) && from && to) {
            const availableTime = (toTime - fromTime) / 60000;
            return Math.floor(availableTime / durationMinutes);
        } else {
            return 0;
        }
    };

    const checkDuplicate = (id, from, to) => {
        const duplicate = formRows.some(
            row => row.id !== id && row.from === from && row.to === to
        );
        return duplicate;
    };

    const onFieldChange = (id, field, value) => {
        const modifiedRows = formRows.map(row => {
            if (row.id === id) {
                const updatedRow = { ...row, [field]: value };

                if (['from', 'to', 'duration'].includes(field)) {
                    updatedRow.appointments = calculateAppointments(updatedRow.from, updatedRow.to, updatedRow.duration);
                }

                // check duplicate only if both from & to present
                if (updatedRow.from && updatedRow.to) {
                    const isDuplicate = checkDuplicate(id, updatedRow.from, updatedRow.to);
                    setScheduleErrors(prev => ({
                        ...prev,
                        [id]: isDuplicate ? "This schedule slot already exists." : ""
                    }));
                    if (isDuplicate) {
                        toast.error("This schedule slot already exists.", {
                            position: "top-center",
                            autoClose: 2000,
                        });
                    }
                } else {
                    setScheduleErrors(prev => ({ ...prev, [id]: "" }));
                }

                return updatedRow;
            }
            return row;
        });
        setFormRows(modifiedRows);
    };

    document.title = "ADD Practice | Form";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h4 className="page-title">ADD Practice</h4>
                        <Link to="/clinic" className="btn btn-danger">View Practice</Link>
                    </div>
                    <Row>
                        <Card>
                            <CardBody>
                                <Form>
                                    <Row>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label>Practice Name</Label>
                                                <Input
                                                    type="text"
                                                    name="name"
                                                    placeholder="Practice Name"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label>Practice Code</Label>
                                                <Input
                                                    type="text"
                                                    name="code"
                                                    placeholder="Practice Code"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label>Practice Email</Label>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Practice Email"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                                {emailError && <div className="text-danger">{emailError}</div>}
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label>Practice contact No.</Label>
                                                <Input
                                                    type="text"
                                                    name="contactno"
                                                     maxLength={11}
                                                    placeholder="E.g - 27843938590"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label>Practice Logo</Label>
                                                <Input
                                                    type="file"
                                                    name="logo"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                                {filePreview && (
                                                    <img
                                                        src={filePreview}
                                                        alt="Practice Logo Preview"
                                                        style={{ marginTop: '10px', maxHeight: '100px', border: '1px solid grey', borderRadius: '4px' }}
                                                    />
                                                )}
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div className="mb-3">
                                                <Label>Region</Label>
                                                <select
                                                    name="region"
                                                    className="form-control"
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    {region.length > 0 ? (
                                                        <>
                                                            <option defaultValue>Select</option>
                                                            {region.map(s => (
                                                                <option key={s._id} value={s._id}>
                                                                    {s.region}
                                                                </option>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <option disabled>No Region Available</option>
                                                    )}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col lg={2}>
                                            <div className="mb-3">
                                                <Label>Ward</Label>
                                                <select
                                                    name="ward"
                                                    className="form-control"
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    {ward.length > 0 ? (
                                                        <>
                                                            <option defaultValue>Select</option>
                                                            {ward.map(s => (
                                                                <option key={s._id} value={s._ward}>
                                                                    {s.ward}
                                                                </option>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <option disabled>No Ward Available</option>
                                                    )}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label>Faculty Manager</Label>
                                                <Input
                                                    type="text"
                                                    name="faculty_manager"
                                                    placeholder="Faculty Manager"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label>Services Rendered</Label>
                                                <Input
                                                    type="text"
                                                    name="services_rendered"
                                                    placeholder="Services Rendered"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label>Address</Label>
                                                <Input
                                                    type="textarea"
                                                    name="address"
                                                    placeholder="Address"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <Label>Comments</Label>
                                                <Input
                                                    type="textarea"
                                                    name="comment"
                                                    placeholder="Comments"
                                                    onChange={(e) => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Schedule Section */}
                                    <Row>
                                        <Col xs={12}>
                                            <Card>
                                               <CardBody>
                                                    <h6 className="mb-4 card-title">Practice Schedule</h6>
                                                    <Form className="repeater" encType="multipart/form-data">
                                                        <div>
                                                            {(formRows || []).map((formRow, key) => (
                                                                <Row key={formRow.id}>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label>From</label>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            value={formRow.from}
                                                                            onChange={(e) => onFieldChange(formRow.id, 'from', e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label>To</label>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            value={formRow.to}
                                                                            onChange={(e) => onFieldChange(formRow.id, 'to', e.target.value)}
                                                                        />
                                                                        {scheduleErrors[formRow.id] && (
                                                                            <div className="text-danger">{scheduleErrors[formRow.id]}</div>
                                                                        )}
                                                                    </Col>
                                                                    <Col lg={1} className="mb-3">
                                                                        <label>Duration</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={formRow.duration}
                                                                            onChange={(e) => onFieldChange(formRow.id, 'duration', e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col lg={2} className="mb-3">
                                                                        <label>Appointments</label>
                                                                        <input
                                                                            className="form-control"
                                                                            value={calculateAppointments(formRow.from, formRow.to, formRow.duration)}
                                                                            readOnly
                                                                        />
                                                                    </Col>
                                                                    <Col lg={1} className="align-self-center">
                                                                        <div className="d-grid">
                                                                            <input
                                                                                type="button"
                                                                                className="btn btn-primary"
                                                                                value="Delete"
                                                                                onClick={() => onDeleteFormRow(formRow.id)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            ))}
                                                        </div>
                                                        <input
                                                            type="button"
                                                            className="btn btn-success mt-3 mt-lg-0"
                                                            value="Add"
                                                            onClick={() => onAddFormRow()}
                                                        />
                                                    </Form>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <div>
                                        <button className="btn btn-primary w-md mx-2" onClick={(e) => handleAddClinic(e)}>
                                            Save
                                        </button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Addclinic;
